import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import {
  CampaniaEncuesta,
  SearchCampaniaEncuestaRequest,
} from '../../model/campania-encuesta/campania-encuesta';

@Injectable({
  providedIn: 'root',
})
export class CampaniaEncuestaService {
  private readonly endPoint = '/CampaniaEncuesta';

  constructor(private dataService: DataService) {}

  async search(request: SearchCampaniaEncuestaRequest): Promise<CampaniaEncuesta[]> {
    return await this.dataService
      .post<CampaniaEncuesta[]>(`${this.endPoint}/search`, request)
      .toPromise();
  }
}
